"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Skipper = function Skipper(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "39",
    height: "35",
    viewBox: "0 0 39 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.357 5.49997C23.357 7.63021 21.6301 9.35711 19.4998 9.35711C17.3696 9.35711 15.6427 7.63021 15.6427 5.49997C15.6427 3.36972 17.3696 1.64282 19.4998 1.64282C21.6301 1.64282 23.357 3.36972 23.357 5.49997ZM20.2289 10.8079C22.8427 10.4522 24.857 8.21134 24.857 5.49997C24.857 2.5413 22.4585 0.142822 19.4998 0.142822C16.5412 0.142822 14.1427 2.5413 14.1427 5.49997C14.1427 8.19685 16.1355 10.4283 18.7289 10.8021V10.8571V13.6785H13.2289C12.8147 13.6785 12.4789 14.0143 12.4789 14.4285C12.4789 14.8428 12.8147 15.1785 13.2289 15.1785H18.7289V33.3052C9.91282 32.9249 2.82612 25.8719 2.39277 17.0701C2.39151 17.0445 2.39947 17.0225 2.41957 17.0021C2.44107 16.9803 2.47371 16.9643 2.51461 16.9643H8.76461C9.17882 16.9643 9.51461 16.6285 9.51461 16.2143C9.51461 15.8 9.17882 15.4643 8.76461 15.4643H2.51461C1.61739 15.4643 0.848064 16.199 0.894584 17.1439C1.37929 26.9888 9.51416 34.8214 19.4789 34.8214C29.4436 34.8214 37.5785 26.9888 38.0632 17.1439C38.1097 16.199 37.3404 15.4643 36.4432 15.4643H30.1932C29.779 15.4643 29.4432 15.8 29.4432 16.2143C29.4432 16.6285 29.779 16.9643 30.1932 16.9643H36.4432C36.4841 16.9643 36.5167 16.9803 36.5382 17.0021C36.5583 17.0225 36.5663 17.0445 36.565 17.0701C36.1317 25.8719 29.045 32.9249 20.2289 33.3052V15.1785H25.7289C26.1431 15.1785 26.4789 14.8428 26.4789 14.4285C26.4789 14.0143 26.1431 13.6785 25.7289 13.6785H20.2289V10.8571V10.8079Z",
    fill: fill
  }));
};
Skipper.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Skipper.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Skipper;